"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpdCssSlider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const TpdCssSlider_style_1 = require("./TpdCssSlider.style");
const TpdCssSlider = (props) => {
    return ((0, jsx_runtime_1.jsx)(TpdCssSlider_style_1.ContainerDiv, Object.assign({ scrollPaddingMobile: props.scrollPaddingMobile, scrollPaddingTablet: props.scrollPaddingTablet, scrollPaddingDesktop: props.scrollPaddingDesktop, columnGapMobile: props.columnGapMobile, columnGapTablet: props.columnGapTablet, columnGapDesktop: props.columnGapDesktop, className: props.maximizeWidth ? "maximize-width" : "fit-width" }, { children: props.list })));
};
exports.TpdCssSlider = TpdCssSlider;
